import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';

@Component({
  selector: 'app-add-writter',
  templateUrl: './add-writter.component.html',
  styleUrls: ['./add-writter.component.css']
})
export class AddWritterComponent implements OnInit {

  image: File;
  imgurl3:any;
  id: any;
  downloadURL: Observable<string>;
  FOLDER: any = 'writers/'
  writerForm:FormGroup;
  loading:boolean=false;
  load:boolean=false;
  constructor(private form:FormBuilder,private router:Router
    ,private afs:AngularFirestore,private auth: AuthService,
    private route: ActivatedRoute,
    private comicService: EcomicService,
     public toastr: ToastsManager,vcr: ViewContainerRef)
   {
    this.toastr.setRootViewContainerRef(vcr);
    }

  ngOnInit() {
    this.writerForm = this.form.group({
      logo:['',[]],
      author_name:['',[Validators.required]],
      description:['',[Validators.required]]
     });
     this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id)
      if (this.id) {
        this.comicService.getsinglenovel(this.id, 'writers').then(writerData => {
          writerData.subscribe(singleWriter => {
        this.writerForm.get('author_name').setValue(singleWriter['author_name']);
        this.writerForm.get('description').setValue(singleWriter['description']);
        this.imgurl3 = singleWriter['imageUrl'];
      }) 
    }) 
      }
    }) 
  }
  async addWriter(value,valid){
    if(valid){
      this.loading=true;
      try{  
        if(this.id){
          let imgaeUrl;
          if(this.image){
            const uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);  
            imgaeUrl = uploadedimage['Location']
          }else{
            imgaeUrl =  this.imgurl3
          }
         
          const partnersdata = await  this.afs.collection('writers').doc(this.id).update({'imageUrl':imgaeUrl,'author_name':value.author_name,'description':value.description,'createdAt':new Date().toString()});
          this.loading = false;
          this.router.navigate(['/our-writers']);
          this.toastr.success('Writers Updated!', 'Success!');
        }else{
          const uploadedimage = await this.auth.uploadimage(this.FOLDER, this.image, false);   
          const partnersdata = await  this.afs.collection('writers').add({'imageUrl':uploadedimage['Location'],'author_name':value.author_name,'description':value.description,'createdAt':new Date().toString()});
          const pid = partnersdata.id;
          const id = await this.afs.doc(`/writers/${pid}`).update({ id: pid });
      
          this.loading = false;
          this.router.navigate(['/our-writers']);
          this.toastr.success('Writers Updated!', 'Success!');
        }
  
  } 
  catch (error) {
    console.log(error)
    this.toastr.error('Somthing went wrong please try later', 'Oops!');
    this.loading = false;
    this.load=true;
  }}}
  


  changeListner3(event) {
    if (event.target.files && event.target.files[0]) {
      this.image = event.target.files[0]
      var reader = new FileReader();

      reader.onload = (event:any) => {
        this.imgurl3 = event.target.result;
      }

      reader.readAsDataURL(event.target.files[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/our-writters/add-writter/add-writter.component.ts